module.exports = __webpack_public_path__ + "img/qrl.76efbee8.svg";